function Date_Plugin() { }

// Convterte a data do tipo 'DD/MM/YYYY' em date para validacoes
Date_Plugin.prototype.convertString = function (p_date) {
    const parts = p_date.split('/');
    return new Date(parts[2], parts[1] - 1, parts[0]);
}

Date_Plugin.prototype.install = function (app) {
    app.datePlugin = this;
    app.config.globalProperties.$datePlugin = this;
}

export function DatePlugin() {
    return new Date_Plugin();
}